export const spacing = 8;

export const shadowFactor = 0.5;

export const defaultButtonBorderWidth = 1.5;
export const defaultBorderRadius = spacing * 1.5;
